import { render } from "./Retailers.vue?vue&type=template&id=437d5891&scoped=true"
import script from "./Retailers.vue?vue&type=script&lang=js"
export * from "./Retailers.vue?vue&type=script&lang=js"

import "./Retailers.vue?vue&type=style&index=0&id=437d5891&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437d5891"]])

export default __exports__